
  import { defineComponent, toRefs } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { Button } from '@/ui/components/Button';
  import { router } from '@/ui/routes';
  import { isNewTabKey, openNewTab } from '@/ui/helpers';

  export default defineComponent({
    name: 'CloneSchedule',
    components: {
      Tooltip,
      Button,
    },
    props: ['id'],
    setup(props) {
      const { id } = toRefs(props);
      const routeObject = {
        name: 'scheduleCreate',
        query: {
          fromId: id!.value.toString(),
        },
      };
      const { href } = router.resolve(routeObject);

      const handleClone = (e: MouseEvent) => {
        if (isNewTabKey(e)) {
          openNewTab(href);
        } else {
          router.push(routeObject);
        }
      };

      return {
        href,
        handleClone,
      };
    },
  });
